"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * HOC which adds a static inner prop to the component
 * @param component React Component
 * @param inner key-value pairs. Key is a component name. Value - component itself.
 * @example
 * const ComponentWithInner = withInner(Component, { InnerComponent1, InnerComponent2 });
 */
function withInner(component, inner) {
    const readonly = Object.defineProperties({}, Object.assign({}, Object.keys(inner).reduce((result, name) => {
        result[name] = {
            configurable: false,
            enumerable: true,
            get() {
                return inner[name];
            },
        };
        return result;
    }, {})));
    return Object.assign(component, {
        inner: readonly,
    });
}
exports.withInner = withInner;
